export const ActionTypes = {
  LOADING: "GET_VALUES_LOADING",
  ERROR: "GET_VALUES_ERROR",
  SUCCESS: "GET_VALUES_SUCCESS",

  CREATE_CUSTOM_SUCCESS: "CREATE_CUSTOM_ROLE_SUCCESS",
  DELETE_CUSTOM_SUCCESS: "DELETE_CUSTOM_ROLE_SUCCESS",
};
